import SogangLogoPng from "./images/sponsor-sogang.png";
import StartlinkLogoSvg from "./images/sponsor-startlink.svg";
import HyunmaiMobisLogoSvg from "./images/sponsor-mobis.svg";
import NaverD2LogoPng from "./images/sponsor-naverd2.png";
import SolvedAcLogoPng from "./images/sponsor-solvedac.png";

export const SPONSOR_SOGANG = {
  name: "서강대학교",
  logoImage: {
    type: "png",
    url: SogangLogoPng,
  },
};

export const SPONSOR_STARTLINK = {
  name: "스타트링크",
  logoImage: {
    type: "svg",
    url: StartlinkLogoSvg,
  },
};

export const SPONSOR_MOBIS = {
  name: "현대모비스",
  logoImage: {
    type: "svg",
    url: HyunmaiMobisLogoSvg,
  },
};

export const SPONSOR_NAVERD2 = {
  name: "네이버 D2",
  logoImage: {
    type: "png",
    url: NaverD2LogoPng,
  },
};

export const SPONSOR_SOLVEDAC = {
  name: "solved.ac",
  logoImage: {
    type: "png",
    url: SolvedAcLogoPng,
  },
};
